/* eslint-disable @typescript-eslint/no-namespace */
/* eslint-disable @typescript-eslint/prefer-namespace-keyword */

import isApiError from "@insite/client-framework/Common/isApiError";
import { ApiParameter, post, ServiceResult } from "@insite/client-framework/Services/ApiService";

export interface ProductFeedbackModel extends ApiParameter {
    productNumber?: string;
    name?: string;
    emailAddress?: string;
    feedback?: string;
    onSuccess?: () => void;
}

const feedbackModalServiceUrl = "/api/v2/email/productfeedback";

export async function getProductFeedbackService(
    parameter: ProductFeedbackModel,
): Promise<ServiceResult<ProductFeedbackModel>> {
    try {
        const productFeedbackModel = await post<ProductFeedbackModel>(
            `${feedbackModalServiceUrl}`,
            parameter as ProductFeedbackModel,
        );
        return {
            result: productFeedbackModel,
            successful: true,
        };
    } catch (error) {
        if (isApiError(error)) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
                statusCode: error.status,
            };
        }
        throw error;
    }
}
